/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  AddAircraftDetails.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Srinivas Grandhi (E528634)
 *
 * @Date	       : Oct 31, 2019
 *
 * @Version      : Version 1.0
 *
 * By           : H224423
 * On           : Nov 28, 2019
 * Description  : ASDS-1474 Accept product terms changes.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1953
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Dec 12, 2019
 * Description   : Removed title text as checbox is available at the end.
 *
 * By            : Suresh Jaladi - E807958
 * On            : Mar 11, 2020
 * Description   : ASDS-1766
 *
 * By             : H422337
 * On             : Sep 07,2020
 * Description    : ASDS-2570 UI enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Sep 14,2020
 * Description    : ASDS-2983 UI enhancements phase II bugfixes
 *
 * By             : H422337
 * On             : Sep 14,2020
 * Description    : ASDS-3140 UI enhancements  phase-2 bugfixes
 *
 * By             : H422337
 * On             : Oct 05,2020
 * Description    : ASDS-3503 UI enhancements  phase-2 bugfixes
 *
 * By            : H422335
 * On            : Oct 09, 2020
 * Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
 *
 * By            : H422337
 * On            : Oct 27, 2020
 * Description   : ASDS-3555 - UI Enhancements for Phase - II -migrate to Forge API
 *
 * By            : H422337
 * On            : Nov 18, 2020
 * Description   : ASDS - 4073 - selection checkbox bug fixes - Phase-2
 *
 ******************************************************************************/

import * as React from 'react';

import { Card, Grid, Select, Icon, Notification, Input } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import './ConfigureWirelessProduct.css';
import 'modules/checkout/ConfigureProduct/ConfigureProduct.css';
import '@scuf/common/honeywell/theme.css';
import '@scuf/datatable/honeywell/theme.css';
import ConfigureWirelessActions from 'modules/checkout/redux/actions/configure-wireless-actions';
import { connect } from 'react-redux';
import { AircraftErrorLabels, CheckoutServiceURL, CheckoutUILabels } from '../../constants/checkout-constants';
import API from '../../API/api';
import { handleResponse, checkUnauthorizedUserError } from '../../API/apiUtils';
import { logError } from '../../../../utils/console-utility';
import GenericLoader from '../../Loader/Loader';
import AcceptTermsCheck from 'modules/checkout/Common/AcceptTermsCheck';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';

interface IAddAircraftDetailsProps {
  wirelessProductId: string;
  aircraftDetailsArray: IAircraftDetailsRowData[];
  deleteRow: Function;
  addNewRow: Function;
  updateSerial: Function;
  updateTail: Function;
  updateAircraftType: Function;
  isAircraftTypeInfoInProgress: boolean;
  aircraftTypeInfoProcessing: Function;
  updateAcceptTermsStatus: Function;
  acceptTermsStatus: boolean;
  acceptTermsErrorMsg: string;
  aircraftTypes: any;
  getAircraftTypes: Function;
  aircraftTypeWirelessDeviceId: string;
  showValidationErrorMsg: boolean;
  hideValidationErrorMsg: Function;
  isEdit: number;

}

interface IAircraftDetailsRowData {
  aircraftType: string;
  aircraftTypeError: string;
  serialNumber: string;
  serialNumberError: string;
  tailNumber: string;
  tailNumberError: string;
  validInputData: boolean;
}

export class AddAircraftDetails extends React.Component<IAddAircraftDetailsProps, any> {

  constructor(props) {
    super(props);
    this.state = {
      selectedRowData: [],
    };
    this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
  }
  componentDidMount() {
    // Call Aircraft type information only once where there is no data. length 1 is because of intial empty row in reducer OR
    // previously selected wireless product id & current wireless product id is not same.
    if ((this.props.aircraftTypes.length === 1 && this.props.aircraftTypes[0].text === "") || this.props.aircraftTypeWirelessDeviceId !== this.props.wirelessProductId) {
      this.fetchAircraftTypes();
    }
    else {
      this.props.aircraftTypeInfoProcessing(false);
    }
  }

  // async fetchAircraftTypes() {
  //   this.props.aircraftTypeInfoProcessing(true);
  //   const url = CheckoutServiceURL.GET_AIRCRAFT_TYPES_URL + `${this.props.wirelessProductId}/aircraft-types`;
  //   const data: any = await API.get(url)
  //     .then(handleResponse)
  //     .catch(error => checkUnauthorizedUserError(error, 'Error while getting aircraft types information'));
  //   if (data) {
  //     this.setState({ TableData: data.aircraftTypes });
  //     this.props.getAircraftTypes(data.aircraftTypes, this.props.wirelessProductId);
  //   }
  //   else {
  //     logError('Error while getting aircraft types information.');
  //   }
  //   this.props.aircraftTypeInfoProcessing(false);
  // }

  async fetchAircraftTypes() {
    this.props.aircraftTypeInfoProcessing(true);
    try {
        const url = CheckoutServiceURL.GET_AIRCRAFT_TYPES_URL + `${this.props.wirelessProductId}/aircraft-types`;
        const response = await API.get(url); // Ensure this returns a promise
        const data = await handleResponse(response); // Assuming handleResponse is async or returns a promise
        if (data) {
            this.setState({ TableData: data.aircraftTypes });
            this.props.getAircraftTypes(data.aircraftTypes, this.props.wirelessProductId);
        }
    } catch (error) {
        logError('Error while getting aircraft types information.', error);
        // Handle error, set state accordingly
    } finally {
        this.props.aircraftTypeInfoProcessing(false);
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.props.isAircraftTypeInfoInProgress &&
          <GenericLoader
            text="Loading Aircraft Type information"
            className="features--loader"
            loading={true}
            overlayColor="rgb(247, 247, 247)"
          />}
        {!this.props.isAircraftTypeInfoInProgress && this.renderModal()}
      </React.Fragment>
    );
  }
  renderModal() {
    const Item = DataTable.ActionBar.Item;
    let ErrorRowData = this.props.aircraftDetailsArray.filter((product: any) => {
      if ('validInputData' in product && !product.validInputData && (product.aircraftTypeError !== '' || product.serialNumberError !== '' || product.tailNumberError !== '')) {
          return product;
      }
  });
    return (
      <React.Fragment>
        <Card className="fullwidthCard">
          <Card.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width={12} className="fullwidthRow cwp-add-aircraft-tab">
                  <DataTable
                    data={this.props.aircraftDetailsArray}
                    onEdit={(newVal, cellData) => this.editData(newVal, cellData)}
                    selectionMode="multiple"
                    selection={this.state.selectedRowData}
                    onSelectionChange={(e) => this.setState({ selectedRowData: e })}
                    expandedRows={ErrorRowData}
                    rowExpansionTemplate={this.rowExpansionTemplate}
                  >
                    <DataTable.HeaderBar>
                      <DataTable.HeaderBar.Item
                        content="Add"
                        iconSize="small"
                        icon="slidercontrols-plus"
                        onClick={() => this.addAircraftMultipleRow()}
                      />
                    </DataTable.HeaderBar>

                    <DataTable.ActionBar>
                      <Item
                        icon={<Icon name="delete" root="common" size="small" />}
                        content="Delete"
                        onClick={() => this.deleteMultipleItems()}
                      />
                    </DataTable.ActionBar>
                    <DataTable.Column field="aircraftType" header="Aircraft Type" placeholder="Enter or Select Aircraft Type" align="left" renderer={(cellData) => this.aircraftEditRenderer(cellData)}  editable={true}/>
                    <DataTable.Column field="serialNumber" header="Aircraft Serial Number" align="left" renderer={(cellData) => this.serialNumberRenderer(cellData)}/>
                    <DataTable.Column field="tailNumber" header="Aircraft Tail Number" align="left" renderer={(cellData) => this.tailNumberRenderer(cellData)}/>
                  </DataTable>

                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className='terms-check'>
                  <AcceptTermsCheck updateAcceptTermsStatus={this.props.updateAcceptTermsStatus} acceptTermsStatus={this.props.acceptTermsStatus} acceptTermsErrorMsg={this.props.acceptTermsErrorMsg} checkboxLabel={CheckoutUILabels.WIRELESS_PRODUCT_TERMS_LABEL} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </Card>
      </React.Fragment >
    );
  }


   serialNumberRenderer(cellData: ICellData) {

        return (
            <Input placeholder="Enter serial number" disabled={false} type="string" className="datatable-text-input" fluid={true} value={cellData.rowData.serialNumber} onChange={(newVal: string) => this.editData(newVal, cellData)} />
        );
  }

  tailNumberRenderer(cellData: ICellData) {

        return (
            <Input placeholder="Enter Tail number" disabled={false} type="string" className="datatable-text-input" fluid={true} value={cellData.rowData.tailNumber} onChange={(newVal: string) => this.editData(newVal, cellData)} />
        );
  }



  rowExpansionTemplate(data: any) {
    let errorMsg: string = '';
    let errorTitle: string = '';

    if (data.tailNumberError !== '') {
        errorMsg = data.tailNumberError;
        if (errorMsg === AircraftErrorLabels.AIRCRAFT_TAIL_ERROR_EMPTY) {
            errorTitle = AircraftErrorLabels.ALL_FIELDS_EMPTY_ERROR;
        }
        else if (errorMsg === AircraftErrorLabels.AIRCRAFT_TAIL_ERROR_INVALID) {
          errorTitle = AircraftErrorLabels.AIRCRAFT_TAIL_NUMBER_INVALID;
      } else {
          errorTitle = AircraftErrorLabels.AIRCRAFT_TAIL_NUMBER_DUBLICATE;
      }

    }
    if (data.serialNumberError !== '') {
        errorMsg = data.serialNumberError;
        if (errorMsg === AircraftErrorLabels.AIRCRAFT_SERIAL_ERROR_EMPTY) {
            errorTitle = AircraftErrorLabels.ALL_FIELDS_EMPTY_ERROR;
        } else if (errorMsg === AircraftErrorLabels.AIRCRAFT_SERIAL_ERROR_INVALID) {
            errorTitle = AircraftErrorLabels.AIRCRAFT_SERIAL_NUMBER_INVALID;
        } else {
            errorTitle = AircraftErrorLabels.AIRCRAFT_SERIAL_NUMBER_DUBLICATE;
        }
    }
    if (data.aircraftTypeError !== '') {
      errorMsg = data.aircraftTypeError;
      if (errorMsg === AircraftErrorLabels.AIRCRAFT_TYPE_ERROR) {
        errorTitle = AircraftErrorLabels.ALL_FIELDS_EMPTY_ERROR;
    }
    }
    if (this.props.showValidationErrorMsg) {
        if (errorTitle === AircraftErrorLabels.ALL_FIELDS_EMPTY_ERROR ) {
            return  <Notification hasIcon={true} severity="important"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideValidationErrorMsg(false); }} >{errorMsg}</Notification>;
        } else {
            return  <Notification hasIcon={true} severity="critical"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideValidationErrorMsg(false); }}  >{errorMsg}</Notification>;
        }
    } else {
       return ;
   }
}

  aircraftEditRenderer(cellData: ICellData) {
    if (this.props.isEdit !== 0 && cellData.rowData.aircraftType !== '' && typeof cellData.rowData.aircraftType === 'string') {
      const aircraftName= cellData.rowData.aircraftType;
      cellData.rowData.aircraftType = this.props.aircraftTypes.filter(aircraft => {
        if(aircraft.text === aircraftName){
          return aircraft;
        }

      });
      cellData.rowData.aircraftType = cellData.rowData.aircraftType.length !== 0 && cellData.rowData.aircraftType[0].value;
    }
    return (
      <React.Fragment>
      <Select
        key={cellData.rowIndex}
        placeholder="Enter or Select Aircraft Type"
        className="aircraft-type-dropdown"
        value={cellData.rowData.aircraftType}
        search={true}
        onChange={(value) => { this.props.updateAircraftType(value, cellData.rowIndex); }}
        options={this.props.aircraftTypes}
      />
      </React.Fragment>
    );
  }
  addAircraftMultipleRow(): void {
    this.props.addNewRow(0);
    this.props.hideValidationErrorMsg(true);
  }
  editData(newVal, cellData): void {
    this.updateSelectedRowData(cellData);
    this.props.hideValidationErrorMsg(true);
    if (cellData.field === 'serialNumber') {
      this.props.updateSerial(newVal, cellData.rowIndex);
    }
    else if (cellData.field === 'tailNumber') {
      this.props.updateTail(newVal, cellData.rowIndex);
    }
  }
  deleteMultipleItems(): void {
      this.props.deleteRow(this.state.selectedRowData);
      this.setState({ selectedRowData: [] });
      if (this.props.aircraftDetailsArray.length === this.state.selectedRowData.length) {
          this.props.addNewRow(0);
      }

  }
  updateSelectedRowData(cellData: ICellData) {
    if (this.state.selectedRowData.length !== 0) {
        const indexFromSelectedRowData = this.state.selectedRowData.findIndex((x: any) => (x.tailNumber === cellData.rowData.tailNumber) && (x.serialNumber === cellData.rowData.serialNumber));
        if (indexFromSelectedRowData !== -1) {
                let  selecedData = [...this.state.selectedRowData];
                selecedData.splice(indexFromSelectedRowData, 1);
                this.setState({selectedRowData: selecedData});
        }
    }
}
}
const mapDispatchToProps = {
  addNewRow: ConfigureWirelessActions.addAircraftRow,
  deleteRow: ConfigureWirelessActions.deleteAircraftRow,
  updateSerial: ConfigureWirelessActions.updateAircraftSerial,
  updateTail: ConfigureWirelessActions.updateAircraftTail,
  updateAircraftType: ConfigureWirelessActions.updateAircraftType,
  aircraftTypeInfoProcessing: ConfigureWirelessActions.aircraftTypeInfoProcessing,
  updateAcceptTermsStatus: ConfigureWirelessActions.updateAcceptTermsStatus,
  getAircraftTypes: ConfigureWirelessActions.getAircraftTypes,
  hideValidationErrorMsg: ConfigureWirelessActions.hideValidationErrorMsg
};
function mapStateToProps(state) {
  return {
    aircraftDetailsArray: state.configWirelessProductData.payload.aircraftDetailsArray,
    isAircraftTypeInfoInProgress: state.configWirelessProductData.payload.isAircraftTypeInfoInProgress,
    acceptTermsStatus: state.configWirelessProductData.payload.acceptTermsStatus,
    acceptTermsErrorMsg: state.configWirelessProductData.payload.acceptTermsErrorMsg,
    aircraftTypes: state.configWirelessProductData.payload.aircraftTypes,
    aircraftTypeWirelessDeviceId: state.configWirelessProductData.payload.aircraftTypeWirelessDeviceId,
    showValidationErrorMsg: state.configWirelessProductData.payload.showValidationErrorMsg,
    isEdit : state.configWirelessProductData.payload.editWirelessProductDetails.productSeq
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAircraftDetails);